// api/calendar/get-calendar/:StartDate/:EndDate

import { api } from "api";

export const getCalendar = (
  startDate,
  endDate,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/calendar/get-calendar/${startDate}/${endDate}`)
      .then((res) => {
        dispatch({
          type: "GET_CALENDAR_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_CALENDAR_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getSuggestedTrainings = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/calendar/get-suggested-trainings")
      .then((res) => {
        dispatch({
          type: "GET_SUGGESTED_TRAININGS_SUCCESS",
          payload: res.data,
        });

        onSuccess(res.data);
      })
      .catch((e) => {
        dispatch({
          type: "GET_SUGGESTED_TRAININGS_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
